import { Typography } from '@mui/material';
import styled from 'styled-components';

export const Elevation = styled.div`
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%),
    0px 1px 5px 0px rgb(0 0 0 / 12%);
`;

export const OptionButton = styled.div`
  display: flex;
  justify-content: space-between;
  padding-right: 8px;
  padding-left: 24px;
  padding-top: 5px;
  align-items: center;
  background-color: white;
`;

export const Title = styled(Typography)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const IconContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 3px;
  width: 90px;
  font-size: 12px;
  background-color: #0394fc;
  padding: 8px;
  border-radius: 10px;
  color: white;
  pointer-events: auto;
  transition: background-color 0.2s;

  &:hover {
    background-color: #007acc; /* Cor diferente para o hover */
  }
`;

export const TableFixes = styled.div`
  div[role='listbox'] > span + span {
    display: none;
  }

  div[role='listbox']::after {
    content: 'linhas';
  }
`;

export const NoElevation = styled.div`
  & > * {
    box-shadow: none !important;
    display: block;
  }

  & table:nth-child(1) tr:nth-child(1) td input {
    padding: 4px 0 5px !important;
  }

  & button {
    padding: 14px !important;
  }

  & p {
    margin-top: 14px !important;
    margin-bottom: 14px !important;
  }

  .MuiAutocomplete-popupIndicator {
    padding: 0 !important;
  }

  & > div:nth-child(1) > div:nth-child(2) > div:first-child {
    display: -ms-grid;
    display: grid;
  }

  .MuiButton-containedPrimary {
    background-color: #1976d2 !important;
  }

  // TODO: Estilizar diretamente nos botões. Está afetando outros botões da tabela.
  .MuiIconButton-root:hover {
    background-color: transparent !important;
    color: inherit !important;
  }

  .MuiTouchRipple-root {
    display: none !important;
  }

  /* .MuiTableBody-root > .MuiTableRow-root > .MuiTableCell-root {
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  } */
`;
